var global = require('../internals/global');
var nativeFunctionToString = require('../internals/function-to-string');

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(nativeFunctionToString.call(WeakMap));



//////////////////
// WEBPACK FOOTER
// /var/www/html/ic-automation/wp-content/themes/digitalcover/node_modules/core-js/internals/native-weak-map.js
// module id = 69
// module chunks = 0